const NetworkIcon = ({ title = '', ...props }) => (
  <svg
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 27 27"
    {...props}
  >
    {title && <title>{title}</title>}
    <path d="m9.818 19.336 3.682 3.665 3.682-3.665a5.23 5.23 0 0 0-7.364 0ZM4.908 14.451l2.455 2.442c3.387-3.371 8.885-3.371 12.273 0l2.454-2.442c-4.743-4.721-12.438-4.721-17.182 0Z" />
    <path d="m0 9.565 2.455 2.443c6.099-6.071 15.991-6.071 22.09 0L27 9.565c-7.456-7.42-19.544-7.42-27 0Z" />
  </svg>
);

export default NetworkIcon;
